var _g, _path, _g2, _path2, _path3, _path4, _path5, _g3, _g4, _rect, _rect2, _rect3, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 170,
    viewBox: "0 0 154 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74.6538,
    cy: 74.8411,
    r: 59.6538,
    fill: "#F0EEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.6538,
    cy: 74.8411,
    r: 61.1538,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M109.236 19.9423L148.14 117.204L94.9706 169.509L40.504 128.875L38.7749 118.069L109.236 19.9423Z",
    fill: "url(#paint0_linear)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.801 131.383H46.9022C42.2337 131.383 38.5161 127.579 38.5161 122.996V24.4379C38.5161 19.8558 42.3201 16.0518 46.9022 16.0518H101.715C106.383 16.0518 110.101 19.8558 110.101 24.4379V122.996C110.187 127.579 106.383 131.383 101.801 131.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.801 131.383H46.9022C42.2337 131.383 38.5161 127.579 38.5161 122.996V24.4379C38.5161 19.8558 42.3201 16.0518 46.9022 16.0518H101.715C106.383 16.0518 110.101 19.8558 110.101 24.4379V122.996C110.187 127.579 106.383 131.383 101.801 131.383Z",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.801 131.383H46.9017C42.2332 131.383 38.5156 127.579 38.5156 122.996V118.76C38.5156 118.328 39.2075 118.501 39.6398 118.501L110.187 118.501V122.996C110.187 127.579 106.383 131.383 101.801 131.383Z",
    fill: "#BEBEBE",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9486 22.1037H66.837C66.3908 22.1037 66.0083 21.5051 66.0083 20.8068C66.0083 20.1085 66.3908 19.51 66.837 19.51H79.0124C79.4586 19.51 79.8411 20.1085 79.8411 20.8068C79.7773 21.5051 79.4586 22.1037 78.9486 22.1037Z",
    fill: "#BFBFBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1879 22.1037H81.6739C81.6181 22.1037 81.5703 21.5051 81.5703 20.8068C81.5703 20.1085 81.6181 19.51 81.6739 19.51H83.1958C83.2516 19.51 83.2994 20.1085 83.2994 20.8068C83.2914 21.5051 83.2516 22.1037 83.1879 22.1037Z",
    fill: "#BFBFBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1309 84.6266C94.616 83.6485 99.7092 103.191 99.7092 103.191C91.6068 110.644 79.8095 111.601 75.2189 111.651C62.1769 111.567 52.0327 104.792 48.7274 101.275C51.49 85.1564 73.0054 84.7643 73.1309 84.6266Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1458 103.235C99.1458 103.235 94.3806 83.6592 73.1342 84.6265C73.0102 84.7656 52.0031 84.8557 49.2869 101.14",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2583 85.7819V94.2437C66.2583 94.2437 68.1216 99.5715 75.2643 99.5715C75.2643 99.5715 82.8729 100.042 83.0281 93.9303V86.5654C83.0281 86.5654 74.7985 94.5571 66.2583 85.7819Z",
    fill: "#F2F2F2",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6439 61.9634L60.2749 77.1633H53.6804C53.6804 77.1633 47.3141 74.9695 47.3141 69.485C47.3141 69.485 46.8482 62.7469 53.8357 61.9634H59.6439Z",
    fill: "white",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5105 61.9634L90.8795 77.1633H96.8476C96.8476 77.1633 103.214 74.9695 103.214 69.485C103.214 69.485 103.68 62.7469 96.6923 61.9634H90.564H91.5105Z",
    fill: "white",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0029 93.0771C71.3554 95.5787 67.2045 90.3671 66.585 87.4485V86.1978C70.55 90.7006 75.0521 90.784 76.8074 90.2628L83.6224 87.7612L83.0029 93.0771Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.8107 69.485C92.8107 80.454 84.0027 90.6395 75.2645 90.6395C66.0987 90.6395 57.7183 80.454 57.7183 69.485C57.7183 66.8211 58.1841 64.3139 58.9605 61.9634C61.7554 54.7552 67.9665 49.5841 75.2645 49.5841C82.873 49.5841 89.2393 55.0686 91.7238 62.5902C92.3449 64.784 92.8107 67.1345 92.8107 69.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8107 69.485C92.8107 80.454 84.0027 90.6395 75.2645 90.6395C66.0987 90.6395 57.7183 80.454 57.7183 69.485C57.7183 66.8211 58.1841 64.3139 58.9605 61.9634C61.7554 54.7552 67.9665 49.5841 75.2645 49.5841C82.873 49.5841 89.2393 55.0686 91.7238 62.5902C92.3449 64.784 92.8107 67.1345 92.8107 69.485Z",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.9912 77.1633V83.588H73.8666",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6992 61.338V56.7937C58.8047 49.4288 66.4133 44.4144 75.264 44.4144C84.4253 44.4144 92.1891 49.8989 95.1394 57.4205V61.338",
    stroke: "#BFBFBF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0132 64.3661C59.0132 64.3661 61.7077 67.717 66.6213 66.4058C69.6328 65.5316 71.3763 64.5118 72.1688 63.7833C72.4858 63.4919 73.1198 63.4919 73.4368 63.929C75.0219 66.1144 80.4109 71.3594 92.457 68.2998",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.7934,
    cy: 74.7015,
    rx: 1.12982,
    ry: 0.847364,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.6335,
    cy: 74.7015,
    rx: 1.41228,
    ry: 0.847364,
    fill: "#BFBFBF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4351 25.5619C84.6736 25.5619 82.4351 27.8005 82.4351 30.5619V52.5502C82.4351 55.3116 84.6736 57.5502 87.4351 57.5502H88.4868V64.4666L95.4032 57.5502H124.985C127.747 57.5502 129.985 55.3116 129.985 52.5502V30.5619C129.985 27.8005 127.747 25.5619 124.985 25.5619H87.4351Z",
    fill: "#EF8B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4868 57.5502H89.4868V56.5502H88.4868V57.5502ZM88.4868 64.4666H87.4868V66.8808L89.1939 65.1737L88.4868 64.4666ZM95.4032 57.5502V56.5502H94.9889L94.696 56.8431L95.4032 57.5502ZM83.4351 30.5619C83.4351 28.3528 85.2259 26.5619 87.4351 26.5619V24.5619C84.1213 24.5619 81.4351 27.2482 81.4351 30.5619H83.4351ZM83.4351 52.5502V30.5619H81.4351V52.5502H83.4351ZM87.4351 56.5502C85.2259 56.5502 83.4351 54.7593 83.4351 52.5502H81.4351C81.4351 55.8639 84.1213 58.5502 87.4351 58.5502V56.5502ZM88.4868 56.5502H87.4351V58.5502H88.4868V56.5502ZM89.4868 64.4666V57.5502H87.4868V64.4666H89.4868ZM94.696 56.8431L87.7797 63.7594L89.1939 65.1737L96.1103 58.2573L94.696 56.8431ZM124.985 56.5502H95.4032V58.5502H124.985V56.5502ZM128.985 52.5502C128.985 54.7593 127.194 56.5502 124.985 56.5502V58.5502C128.299 58.5502 130.985 55.8639 130.985 52.5502H128.985ZM128.985 30.5619V52.5502H130.985V30.5619H128.985ZM124.985 26.5619C127.194 26.5619 128.985 28.3528 128.985 30.5619H130.985C130.985 27.2482 128.299 24.5619 124.985 24.5619V26.5619ZM87.4351 26.5619H124.985V24.5619H87.4351V26.5619Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 91.9448,
    y: 32.7422,
    width: 30.2592,
    height: 1.7291,
    rx: 0.864549,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 91.9448,
    y: 39.6586,
    width: 28.5301,
    height: 1.7291,
    rx: 0.864549,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 91.9448,
    y: 46.575,
    width: 24.2074,
    height: 1.7291,
    rx: 0.864549,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6537,
    cy: 124.985,
    r: 2.59365,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0.187256,
    width: 153.308,
    height: 153.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.766667 0 0 0 0 0.753889 0 0 0 0 0.753889 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 32.5161,
    y: 10.0518,
    width: 87.5861,
    height: 131.331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 51.7183,
    y: 43.5841,
    width: 51.0924,
    height: 57.0554,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 76.4351,
    y: 19.5619,
    width: 63.5502,
    height: 56.3189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 46.5558,
    y1: 49.7692,
    x2: 113.991,
    y2: 149.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 66.585,
    y1: 86.1978,
    x2: 82.2383,
    y2: 92.6385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.3155,
    height: 67.2243,
    fill: "white",
    transform: "translate(45.7617 42.2192)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallUs);
export default __webpack_public_path__ + "static/media/call-us.433351003db4d44f98e6d4049a2a5c9b.svg";
export { ForwardRef as ReactComponent };